
<app-splash
  [clientSetting]="getClientsSettingAppAuth"
  [showSplashScreen]="showSplashScreen"
></app-splash>

<app-notification-container></app-notification-container>

<div *ngIf="loadSetting && getClientsSettingAppAuth">

  <ng-container *ngIf="getClientsSettingAppAuth && heroVariant === 'classic'">
    <div class="section-header">
      <app-header class="app-header" [clientSetting]="getClientsSettingAppAuth">
      </app-header>
    </div>
    <!-- variante 'classic': login en su propia sección arriba de las cards, como siempre.
        variante 'animated': el login se muestra dentro del panel 1 del hero (ver <app-hero>). -->
    <div class="section-login" >
      <div class="row landS1 pt-5"
        [ngStyle]="{'background-image': imageUrl}">
        <div class="container pt-5">
          <div class="row pt-5" id="adjust-section-login">
            <div class="col-12 col-md-12">
              <h2 class="s-xl title-login text-center">Sitio exclusivo para operadores mayoristas</h2>
            <!--  <h2 class="s-xl title-login text-center">Exclusive site for travel agents</h2> Acá   -->
            </div>
          </div>
          <div class="row" id="adjust-section-login">

            <div class="col-12 col-md-1"></div>
            <div class="col-12 col-md-10 s1-login"
            [ngStyle]="{'background-color':  getClientsSettingAppAuth?.clients_setting_global?.color_main_2}">
              <login [clientSetting]="getClientsSettingAppAuth"></login>
            </div>
            <div class="col-12 col-md-1"></div>
            <div class=" d-none d-md-block col-md-1">
            </div>
          </div>
        </div>
      </div>
    </div>

  </ng-container>

  <app-hero
    *ngIf="sectionAboutUs"
    [variant]="heroVariant"
    [sectionAboutUs]="sectionAboutUs"
    [backgroundImageUrl]="imageUrl"
    [accentColor]="getClientsSettingAppAuth?.clients_setting_global?.color_main_1"
    [clientSetting]="getClientsSettingAppAuth"
    [routeUploadFile]="routeUploadFile"
    [imagesAboutUs]="imagesAboutUs"
    [titleContext]="titleContext"
    (openRegisterModal)="changeOpenModal()"
  ></app-hero>
  <!----------------Button gruoup about me----------------------------------->
  <!-- <div class="container" *ngIf="sectionAboutUs">
    <div class="flex d-flex flex-wrap justify-content-around mt-3 mt-md-5" id="buttonGroup-about-seccion">
      <div class="col-md-6 col-lg-5 col-xl-3">
        <p>
          <button class="btn btn-card " id="icon-button1" title="icon-button1"
            [ngStyle]="{'background-color': sectionAboutUs?.about?.bottom_color}">
          </button>
        </p>
      </div>
      <div class="col-md-6 col-lg-5 col-xl-3">
        <p>
          <button class="btn btn-card " id="icon-button2" title="icon-button2"
            [ngStyle]="{'background-color': sectionAboutUs?.tecnology?.bottom_color}">
          </button>
        </p>
      </div>
      <div class="col-md-6 col-lg-5 col-xl-3">
        <p>
          <button class="btn btn-card " id="icon-button3" title="icon_button3"
            [ngStyle]="{'background-color': sectionAboutUs?.fairs?.bottom_color}">
          </button>
        </p>
      </div>
    </div>
  </div> -->

  <app-partners [images]="images"></app-partners>

  <div *ngIf="sectionDestinity?.info" class="section-destinity" [ngStyle]="{'background-color':getClientsSettingAppAuth?.clients_setting_global?.color_main_2}">
    <div class="container">
      <div class="row">
        <ng-container *ngFor="let destiny of sectionDestinity?.info; let i = index">
          <div class="container-items-section-destiny col-md-3 col-sm-12 col-12 d-flex flex-column align-items-center text-center">
              <p class="pt-1  title-number" appCountUp
                [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}"> {{destiny?.title}}</p>
              <p class="title-dest">{{destiny?.title_sub}}</p>
              <p class="text-white sub-title-dest">{{destiny?.context}} </p>
              <div style="height: 2px;">
                  <div
                    class="hero-line-nav-item"
                    [ngStyle]="{'background':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}"
                  ></div>
              </div>

          </div>

        </ng-container>
      </div>

    </div>
  </div>

  <div *ngIf="sectionTraining?.carousel" class="section-training" [ngStyle]="{'background-color': getBackgroundLearning(), 'padding-bottom': getPaddingBottomLearning()}">
    <div class="academy"
      [ngStyle]="{'background-image': 'url(&quot;' + routeUploadFile+sectionTraining?.background_image + '&quot;)'}">
      <div id="carouselExampleControls">
        <div class="carousel-inner">
          <div class="carousel-item" *ngFor="let item of sectionTraining?.carousel;let index = index;let isFirst = first"
            [ngClass]="{active:isFirst}">
            <div class="layer">
              <div class="container">
                <div class="row academy-grids">
                  <div class="col-lg-12 academy-text-booking">
                    <h3 class="heading mb-4 text-center text-uppercase">{{item.title}}</h3>
                    <div class="form-style-booking academy-btn text-center">
                      <div class="comming-song" [ngStyle]="{'background-color':sectionTraining.learning?.background_color}">
                        <p class="text-comming-song" [ngStyle]="{'color':sectionTraining?.learning?.color}">PRÓXIMAMENTE</p>
                      </div>
                      <!-- <button class="btn-button" style=" width: 12% !important; cursor:default !important"
                        [ngStyle]="{'background-color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">PRÓXIMAMENTE</button> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="e-learning container-fluid" >
      <div class=" row-seccion-e">
        <ng-container *ngFor="let learning of textLearning; let i = index">
           <div class="col-md-3 col-sm-12 col-12 text-center mb-4 card-e-learning"
                appRevealOnScroll [revealDelay]="i * 120"
                [ngStyle]="{'background-color': sectionTraining.learning?.background_color }"
                [style.--color-main-1]="getClientsSettingAppAuth?.clients_setting_global?.color_main_1">
                <div class=" container-card-e-learning">
                  <div>
                    <p [ngStyle]="{'color': sectionTraining.learning?.subtitle }" class="title-e-learning text-left">{{learning?.title}}</p>
                    <p [ngStyle]="{'color': sectionTraining.learning?.color }" class="subtitle-e-learning text-left">{{learning?.title_sub}}</p>
                    <p [ngStyle]="{'color': sectionTraining.learning?.color }" class="subtitle-e-learning-parrafo text-left">{{learning?.context}}</p>
                  </div>
                  <div>
                    <p>
                      <a href="#/articles">
                        <img #iconLearning loading="lazy" class="icon-e-learning" src="/assets/img/app/icon-coment.svg" />
                      </a>
                    </p>
                  </div>
                </div>
            </div>
        </ng-container>
      </div>

      <!------------------------------ Button group e-learning --------------------------------->


    </div>
  </div>
  <div class="section-register">
    <div class="pt-5" style="margin-bottom: 150px;">
      <p class="pt-5 title-black text-uppercase">Registrate</p>
      <!-- .container agregado: esta fila de Bootstrap tiene el margin negativo de siempre
           (-15px por lado) pero no tenía nada alrededor que lo compense, así que se comía
           15px del borde derecho del viewport en casi cualquier ancho (overflow horizontal
           de toda la página, línea blanca en el borde). El .container le da el padding que
           cancela ese margen, sin tocar la regla #adjust-section-login (compartida con el
           login clásico, que si está bien contenido en su .container propio). -->
      <div class="container">
        <div class="row" id="adjust-section-register">
          <div class="col-md-2 col-sm-12 col-12">
          </div>
          <div class="col-md-8 col-sm-12 col-12 text-center">
            <svg-icon src="../../assets/img/app/mouse.svg" id="icon-mouse"
              [ngStyle]="{'fill':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}"></svg-icon>
            <p class="title-joinus text-center pt-4" style="text-transform: uppercase;">UNITE A {{getClientsSettingAppAuth?.name}}</p>
            <p class="subtitle-joinus text-center">{{sectionRegister?.title_sub}}

            </p>
              <button #modalJoinus
                      title="modalJoinus"
                      class="view-more text-center"
                      data-toggle="modal"
                      data-target="#modalJoinus"
                      style="border: none; background: none;width: 100%"
                      (click)="changeOpenModal()"
                      [ngStyle]="{'color':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}">
                Entrá acá para registrarte
              </button>
            <button *ngIf="!buttonSuccess" class="border-0 bg-white" #openModalSuccessJoinUs data-toggle="modal" data-target="#modalRes" style="pointer-events: none;"></button>
          </div>
          <div class="col-md-2 col-sm-12 col-12">
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade center" id="modalJoinus" tabindex="-1" role="dialog" [attr.aria-hidden]="!isModalOpen ? 'true' : null">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class=" bg-white landS5" id="signup">
            <div class="modal-header">
              <div class="col-12">
                <p class="pt-0 title-black text-title-sm"> REGISTRATE </p>
                <div class="text-center">
                  <svg-icon src="../../assets/img/app/mouse.svg" id="icon-mouse2"
                    [ngStyle]="{'fill':getClientsSettingAppAuth?.clients_setting_global?.color_main_1}"></svg-icon>
                </div>
              </div>
              <button #closeButton type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-12 pb-5" *ngIf="getClientsSettingAppAuth">
                <signup class="s1-signup-form darkblue" (successEvent)="successEvent()" (errorEvent)="errorEvent()" [clientSetting]="getClientsSettingAppAuth"></signup>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade center" id="modalRes" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
          <div class="d-flex justify-content-center bg-white modalResSignUp">
            <div class="modal-header">
              <p>Datos registrados con éxito</p>
              <button #closeButtonModalSuccessSignUp class="closeButtonModalSuccessSignUp" type="button" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
      </div>
    </div>


  </div>

  <div *ngIf="getClientsSettingAppAuth" class="section-footer">
    <usb-footer [clientSetting]="getClientsSettingAppAuth"></usb-footer>
  </div>
</div>
